var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkOrangeLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73504 4.58112C4.73504 2.78737 6.18916 1.33325 7.98291 1.33325C9.77665 1.33325 11.2308 2.78737 11.2308 4.58112V6.80334H12.0855C13.124 6.80334 13.9658 7.6452 13.9658 8.68368V12.7862C13.9658 13.8247 13.124 14.6666 12.0855 14.6666H3.88034C2.84186 14.6666 2 13.8247 2 12.7862V8.68368C2 7.6452 2.84186 6.80334 3.88034 6.80334H4.73504V4.58112ZM5.76068 6.80334H10.2051V4.58112C10.2051 3.35382 9.21021 2.35889 7.98291 2.35889C6.75561 2.35889 5.76068 3.35382 5.76068 4.58112V6.80334ZM3.88034 7.82898C3.4083 7.82898 3.02564 8.21164 3.02564 8.68368V12.7862C3.02564 13.2583 3.4083 13.6409 3.88034 13.6409H12.0855C12.5575 13.6409 12.9402 13.2583 12.9402 12.7862V8.68368C12.9402 8.21164 12.5575 7.82898 12.0855 7.82898H3.88034ZM7.98291 9.53838C8.26613 9.53838 8.49573 9.76798 8.49573 10.0512V11.4187C8.49573 11.7019 8.26613 11.9315 7.98291 11.9315C7.69968 11.9315 7.47008 11.7019 7.47008 11.4187V10.0512C7.47008 9.76798 7.69968 9.53838 7.98291 9.53838Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkOrangeLock);
export default __webpack_public_path__ + "static/media/dark-orange-lock.eb851bce961d2d7596f3676b3b28eb5e.svg";
export { ForwardRef as ReactComponent };